import axios from "axios";
import params from "../../../config/params";

require("dotenv").config();

let BASE_URL = params.PROD.CLIENT.SCHEDULE_COLLECTION.COLLECTIONS.BASE_URL;

if (process.env.NODE_ENV === "development") {
  BASE_URL = params.DEV.CLIENT.SCHEDULE_COLLECTION.COLLECTIONS.BASE_URL;
}
if (process.env.NODE_ENV === "qa") {
  BASE_URL = params.QA.CLIENT.SCHEDULE_COLLECTION.COLLECTIONS.BASE_URL;
}

const getAllInverseOrders = sapcode => {
  return axios.get(`${BASE_URL}?sapcode=${sapcode}`);
};

const cancelCollectionDate = req => {
  return axios.post(`${BASE_URL}/cancel`, req);
};

const approveCollectionDate = req => {
  return axios.post(`${BASE_URL}/approve-schedule`, req);
};

export default {
  cancelCollectionDate,
  getAllInverseOrders,
  approveCollectionDate
};
